import React from "react"
import styled from "styled-components";

// Label specifically for screen readers that doesn't show on the page
const SRLabel = styled.label`
    position:absolute;
    left:-10000px;
    top:auto;
    width:1px;
    height:1px;
    overflow:hidden;
`

const IconWrapper = styled.span`
    padding: 0 0.5em 0 0;
    display: block;
    color: #ffffff;
`

const Dropdown = styled.select`
    box-sizing: border-box;
    appearance: none;
    background: transparent;
    padding: 0 1em 0 0.5em;
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    cursor: pointer;
    line-height: inherit;
    outline: none;
    border: none;
    border-left: 1px solid #999;
    width: 100%;
    z-index: 20;
    color: #ffffff;

    & option {
        color: #000000;
    }
`

const DropdownWrapper = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    padding: 0.5em 1em;
    border: 1px solid #999;
    height: 50px;
    border-radius: 25px;
    flex: 0 0 50px;
    &::after {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        content: "";
        width: 0.8em;
        height: 0.5em;
        background-color: #ffffff;
        clip-path: polygon(100% 0%, 0 0%, 50% 100%);
        z-index: 10;
    }
`

const DeviceSettingsDropdown = ({icon, srLabel, value, options, onChange, id}) =>
    <DropdownWrapper>
        <IconWrapper>
            {icon}
        </IconWrapper>
        <SRLabel htmlFor={id}>{srLabel}</SRLabel>
        <Dropdown id={id} onChange={onChange} value={value}>
            {options.map((option) => (
                <option value={option.value} key={option.value}>{option.label}</option>
            ))}
        </Dropdown>
    </DropdownWrapper>

export default DeviceSettingsDropdown
